import { Pipe, PipeTransform } from '@angular/core';
import { LatLngLiteral } from '@padspin/mapping';

/**
 * It is often more ergonomic to store lat and lng flat in Firestore with other
 * properties in the document so querying is easier. This pipe makes it easy to
 * pass just google.maps.LatLngLiteral to the google-maps components.
 * @example
 * ```typescript
 * @Component({
 *   selector: 'example',
 *   template: '<google-map [center]="config | latLngFromObj" />'
 * })
 * export class ExampleComponent { config = { name: 'example', lat: 0, lng: 0 } }
 * ```
 */
@Pipe({
  name: 'latLngFromObj',
  standalone: true,
})
export class DeriveLatLngPipe implements PipeTransform {
  transform(value: unknown): LatLngLiteral {
    const defaultLatLngLiteral: LatLngLiteral = { lat: 0, lng: 0 };
    if (typeof value !== 'object' || value === null) {
      return defaultLatLngLiteral;
    }
    if (!('lat' in value) || !('lng' in value)) {
      return defaultLatLngLiteral;
    }
    const latLngLiteral: LatLngLiteral = {
      lat: 0,
      lng: 0,
    };
    Object.entries(value).map((entry) => {
      if (entry[0] === 'lat') {
        latLngLiteral.lat = Number(entry[1]);
      }
      if (entry[0] === 'lng') {
        latLngLiteral.lng = Number(entry[1]);
      }
    });

    return latLngLiteral;
  }
}
